import { useQuery } from '@tanstack/react-query';
import { Link, useLocation } from 'react-router-dom';
import { api } from '../api.js';
import {
  hidesGlobalPlayerBar,
  isPathPlayerBarRoute,
  pathPlayerBarData,
} from '../player-bar-context.js';
import { useAppStore } from '../store.js';
import { Avatar } from './Avatar.js';
import { HomePlayerBar } from './HomePlayerBar.js';

export function GlobalPlayerBar() {
  const location = useLocation();
  const session = useAppStore((state) => state.session);
  const pathContext = isPathPlayerBarRoute(location.pathname);
  const hidePlayerBar = hidesGlobalPlayerBar(location.pathname);
  const query = useQuery({
    queryKey: ['home'],
    queryFn: api.home,
    enabled: !hidePlayerBar,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
  const pathQuery = useQuery({
    queryKey: ['path'],
    queryFn: api.path,
    enabled: pathContext && !hidePlayerBar,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });

  const cards = useQuery({
    queryKey: ['reward-cards', 'count'],
    queryFn: api.rewardCardCount,
    enabled: !hidePlayerBar,
    staleTime: 15_000,
    refetchInterval: 30_000,
  });
  if (hidePlayerBar) return null;
  if (query.data && pathContext && pathQuery.data) {
    const playerBar = pathPlayerBarData(query.data, pathQuery.data);
    return (
      <HomePlayerBar
        className="global-player-bar"
        readyCards={cards.data?.count ?? 0}
        user={playerBar.user}
        energy={playerBar.energy}
        context={playerBar.context}
        energyOffer={query.data.energy.purchaseOffer}
      />
    );
  }
  if (query.data && !pathContext)
    return (
      <HomePlayerBar
        className="global-player-bar"
        readyCards={cards.data?.count ?? 0}
        user={query.data.user}
        energy={query.data.energy}
        energyOffer={query.data.energy.purchaseOffer}
      />
    );

  const name = session
    ? `${session.user.firstName} ${session.user.lastName ?? ''}`.trim()
    : 'Игрок';
  return (
    <div
      className={`home-player-bar global-player-bar is-loading ${pathContext ? 'is-path-context' : ''}`.trim()}
      aria-label="Данные игрока загружаются"
    >
      <Link className="home-player-identity" to="/profile" aria-label={`Открыть профиль: ${name}`}>
        <Avatar name={name} url={session?.user.avatarUrl ?? null} size={38} />
        <div className="home-player-name">
          <strong>{name}</strong>
          <span>
            {query.isError || (pathContext && pathQuery.isError)
              ? 'Данные временно недоступны'
              : 'Обновляем баланс…'}
          </span>
        </div>
      </Link>
      <span className="global-player-stat-skeleton" />
      <span className="global-player-stat-skeleton" />
    </div>
  );
}
